// @ts-nocheck

import { request } from '../../../../../../context';
import type { ApiOptions } from '../../../../../../context';
import type { BaseResponseWebPagePluginConfig } from '../../../../../../types';

/**
 * 自动生成陪练网页插件
 *
 * @export
 * @tags 租户接口
 * @link [GET] /companys/intelligent/partner/webPage/plugin/generate
 */
export function getCompanysIntelligentPartnerWebPagePluginGenerate(): Promise<BaseResponseWebPagePluginConfig>;
export function getCompanysIntelligentPartnerWebPagePluginGenerate(
    options: ApiOptions<never, never>
): Promise<BaseResponseWebPagePluginConfig>;
export function getCompanysIntelligentPartnerWebPagePluginGenerate(
    options?: ApiOptions<never, never>
): Promise<BaseResponseWebPagePluginConfig> {
    return request<never, never, never>('/companys/intelligent/partner/webPage/plugin/generate', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCompanysIntelligentPartnerWebPagePluginGenerate',
    });
}

export const meta = [
    {
        tags: ['租户接口'],
        path: '/companys/intelligent/partner/webPage/plugin/generate',
        method: 'get',
    },
];
